import { useMemo } from 'react';
import { Activity } from '../../models/view';
import { useAppSelector } from '../../store';

export const useScheduleItems = () => {
  const { programEvents, error: programEventsError, loading: programEventsLoading } = useAppSelector(
    (state) => state.programEvents,
  );
  const {
    graduwayEvents,
    error: graduwayEventsError,
    loading: graduwayEventsLoading,
  } = useAppSelector((state) => state.graduwayEvents);

  const programEventItems = useMemo((): Activity[] => {
    return programEvents.map((event) => ({
      id: event.id.toString(),
      sfid: event.sfid,
      title: event.volunteerJob.name,
      description: event.description,
      dateTime: new Date(event.startDateTime),
      duration: event.duration,
      location: event.volunteerJob.locationInformation,
      source: 'programEvent',
    }));
  }, [programEvents]);

  const graduwayEventItems = useMemo((): Activity[] => {
    return graduwayEvents
      .filter((event) => event.status === 'active' && event.eventDate)
      .map((event) => ({
        id: `graduway-${event.id}`,
        title: event.title,
        description: event.description,
        dateTime: new Date(event.eventDate!),
        location: event.location,
        source: 'graduwayEvent',
        eventUrl: event.eventUrl,
        eventTime: event.eventTime,
        imageUrl: event.imageUrl,
      }));
  }, [graduwayEvents]);

  const scheduleItems = useMemo((): Activity[] => {
    return [...programEventItems, ...graduwayEventItems];
  }, [programEventItems, graduwayEventItems]);

  const error = programEventsError || graduwayEventsError;
  const loading = programEventsLoading || graduwayEventsLoading;

  return { scheduleItems, programEventItems, graduwayEventItems, error, loading };
};
